
import { useNavigate, useParams } from "react-router-dom";
import { XCircle, ArrowLeft, CreditCard } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Card } from "@/components/ui/card";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";

const PaymentCancel = () => {
  const navigate = useNavigate();
  const { applicationId } = useParams();

  return (
    <div className="min-h-screen flex flex-col bg-gray-50">
      <Navbar />
      
      <main className="flex-grow pt-8 pb-12 flex items-center justify-center">
        <div className="container mx-auto px-4 md:px-6">
          <div className="max-w-2xl mx-auto text-center">
            <Card className="p-8">
              <div className="space-y-6">
                <div className="flex justify-center">
                  <XCircle className="w-16 h-16 text-red-500" />
                </div>
                
                <div>
                  <h1 className="text-3xl font-bold text-gray-900 mb-2">
                    Payment Cancelled
                  </h1>
                  <p className="text-gray-600">
                    Your payment was cancelled. No charges have been made to your account.
                  </p>
                </div>

                <div className="space-y-3">
                  {applicationId && (
                    <Button 
                      onClick={() => navigate(`/payment/${applicationId}`)}
                      className="w-full bg-emu-blue hover:bg-emu-blue/90"
                    >
                      <CreditCard className="mr-2 w-4 h-4" />
                      Try Payment Again
                    </Button>
                  )}
                  
                  <Button 
                    variant="outline"
                    onClick={() => navigate('/mentee-dashboard')}
                    className="w-full"
                  >
                    <ArrowLeft className="mr-2 w-4 h-4" />
                    Back to Dashboard
                  </Button>
                </div>
              </div>
            </Card>
          </div>
        </div>
      </main>
      
      <Footer />
    </div>
  );
};

export default PaymentCancel;
